<template>
  <v-app>
    <AppDrawer v-if="isAuthenticated"/>
    <AppToolbar v-if="isAuthenticated"/>
    <v-content class="white">
      <router-view></router-view>
    </v-content>
    <AppOverlay/>
    <vue-snackbar/>
  </v-app>
</template>

<style>
.v-content {
  height: 100%;
}
</style>

<script>
import AppDrawer from '@/components/AppDrawer.vue';
import AppToolbar from '@/components/AppToolbar.vue';
import AppOverlay from '@/components/AppOverlay.vue';

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppOverlay,
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
};
</script>
